import RateManagement from '../../components/admin/RateManagement';

export default function AdminRates() {
  return (
    <div className="py-8 px-4 sm:px-6 lg:px-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Cost Health</h1>
        <p className="mt-1 text-sm text-gray-500">
          Read-only view of provider rates and automated drift detection.
          Rates live in code; updates ship as PRs.
        </p>
      </div>
      <RateManagement />
    </div>
  );
}
